import { defineMessages } from 'react-intl';

const translations = {
  title: {
    id: 'pages.viewPurgeRequest.title',
    defaultMessage: 'Purge request',
    description: 'title of the view purge request page',
  },
  expiredTitle: {
    id: 'pages.viewPurgeRequest.expiredTitle',
    defaultMessage: 'Purge request expired',
    description: 'expired title of the view purge request page',
  },
  usedTitle: {
    id: 'pages.viewPurgeRequest.usedTitle',
    defaultMessage: 'Used purge request token',
    description: 'used title of the view purge request page',
  },
  description: {
    id: 'pages.viewPurgeRequest.description',
    defaultMessage:
      '{requester} requested to purge your tenant of the data records stated below. Purging your tenant of this data means that the information is permanently deleted. We can not recover this data after you purged your tenant.',
    description: 'description of the view purge request page',
  },
  expiredDescription: {
    id: 'pages.viewPurgeRequest.expiredDescription',
    defaultMessage:
      '{requester} requested to purge your tenant. The request has already expired but included the data records stated below.',
    description: 'expired description of the view purge request page',
  },
  usedDescription: {
    id: 'pages.viewPurgeRequest.usedDescription',
    defaultMessage: 'This purge request token was already used. Please sent a new purge request.',
    description: 'used description of the view purge request page',
  },
  expiryNotice: {
    id: 'pages.viewPurgeRequest.expiryNotice',
    defaultMessage: 'This purge request expires {date}',
    description: 'expiry notice on the view purge request page',
  },
  dataToPurge: {
    id: 'pages.viewPurgeRequest.dataToPurge',
    defaultMessage: 'data to purge',
    description: 'data to purge label on the view purge request page',
  },
  confirmPurgeData: {
    title: {
      id: 'pages.viewPurgeRequest.confirmPurgeData.title',
      defaultMessage: 'Purge data',
      description: 'title of the purge data confirm',
    },
    description: {
      id: 'pages.viewPurgeRequest.confirmPurgeData.description',
      defaultMessage:
        'Are you absolutely sure you want to purge you tenant of this data? The data will be permanently deleted and can not be recovered.',
      description: 'description of the purge data confirm',
    },
    buttons: {
      cancel: {
        id: 'actions.cancel',
        defaultMessage: 'Cance;',
        description: 'label of the cancel button',
      },
      purge: {
        id: 'actions.purge',
        defaultMessage: 'Purge',
        description: 'label of the purge button',
      },
    },
  },
  actions: {
    purge: {
      id: 'actions.purge',
      defaultMessage: 'Purge',
      description: 'label of the purge button',
    },
    cancel: {
      id: 'actions.cancel',
      defaultMessage: 'Cancel',
      description: 'label of the cancel button',
    },
  },
  feedback: {
    purgeStarted: {
      id: 'pages.viewPurgeRequest.feedback.purgeStarted',
      defaultMessage: 'Purge started',
      description: 'feedback on the successful start of a purge',
    },
    purgeNotStarted: {
      id: 'pages.viewPurgeRequest.feedback.purgeNotStarted',
      defaultMessage: 'Purge ould not be started',
      description: 'feedback on the failed start of a purge',
    },
  },
};

export default defineMessages(translations);
